<template>
  <div class="print">
    <section class="section-stdInfo">
      <div>
        <p class="print-title mb-10">{{ $t('추락사고 예방') }}</p>
        <div class="division-title">{{ $t('□ 기본정보') }}</div>
      </div>

      <table class="w-full">
        <colgroup>
        </colgroup>
        <tr>
          <th>{{ $t('회사명') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.field_name }} </div>
          </td>
          <th>{{ $t('작성자 성명') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.writer_name }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('점검자') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.점검자 }} </div>
          </td>
          <th>{{ $t('점검일') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.점검일 }} </div>
          </td>
        </tr>
        <tr>
          <th>{{ $t('점검장소') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.점검장소 }} </div>
          </td>
          <th>{{ $t('작성일') }}</th>
          <td>
            <div class="print-input"> {{ form.stdInfo.date }} </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section-inspect mb-10">
      <div class="division-title">□ {{ $t('예방 점검표') }}</div>

      <table class="w-full">
        <colgroup>
          <col />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="180" />
        </colgroup>
        <tr>
          <th>{{ $t('점검내용') }}</th>
          <th>{{ $t('양호') }}</th>
          <th>{{ $t('미흡') }}</th>
          <th>{{ $t('해당없음') }}</th>
          <th>{{ $t('비고(보완계획)') }}</th>
        </tr>
        <template v-for="(item, i) in form.inspectList" >
          <tr v-if="!!item.title && (i === 0 || form.inspectList[i].title !== form.inspectList[i - 1].title)"  :key="`inspect_${i}_header`">
            <th colspan="5"><div v-html="item.title" class="flex items-center justify-start text-left"></div></th>
          </tr>
          <tr :key="`inspect_${i}`">
            <td v-html="$t(item.content)" style="white-space: pre-line"></td>
            <td>
              <PrintCheckbox :value="item.isChecked === '양호'" class="flex justify-center"/>
            </td>
            <td>
              <PrintCheckbox :value="item.isChecked === '미흡'" class="flex justify-center"/>
            </td>
            <td>
              <PrintCheckbox :value="item.isChecked === '해당없음'" class="flex justify-center"/>
            </td>
            <td>
              {{ item['비고(보완계획)'] }}
            </td>
          </tr>
        </template>
      </table>
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: {PrintCheckbox},

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
  computed: {
    processedDisasterType() {
      const disasterType = this.form.stdInfo.재해형태;
      if (!disasterType) return '';

      if (disasterType.includes('직접입력_')) {
        return disasterType.replace('직접입력_', '');
      }

      return this.$t(disasterType);
    }
  }
}
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: bold;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
      word-break: break-word;
      white-space: normal;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 1.5rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 결재란 */
  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;

    .table-approval-field {
      th { width: 120px; padding: 10px 14px;}
      th:first-child { width: 38px }
      td { height: 80px; }

      tr:last-child {
        th, td { border-bottom: none }
      }
    }
  }

  /* 기본정보 */
  .section-stdInfo {
    th { width: 140px; }
    td div { border: none; }
  }

  /* 점검대상 */
  .section-inspect {
    td {
      padding: 1rem;
      text-align: left
    }
  }

  .section-file {
    th { width: 234px; }
  }

  .section-photo {
    td { padding: 1rem; }
  }
}


@media print {
  .page-break { page-break-inside:avoid; page-break-after:auto }
}
</style>
